import Component from '@glimmer/component';
import ActionItemTemplate from 'garaje/components/homepage/kiosk-demo/pages/templates/action-item-template';
import PageTemplate from 'garaje/components/homepage/kiosk-demo/pages/templates/page-template';

import type { KioskDemoPage } from '../provider';

export default class LegalDocs extends Component<KioskDemoPage> {
  get shareLink(): string {
    if (this.args.firstFlowId) {
      return `/visitors/settings/visitor-types/${this.args.firstFlowId}/legal-documents`;
    }
    return '/visitors/settings';
  }

  <template>
    <PageTemplate
      @headerTitle="Legal documents"
      @headerInfo="Visitors sign documents directly on the visitors iPad kiosk. You can use the default NDA provided or add your own legal document."
      @currentStep={{@currentStep}}
      @totalStepCount={{@totalStepCount}}
      @demoName={{@demoName}}
      @isUserLoggedIn={{@isUserLoggedIn}}
      @isDemoInstance={{@isDemoInstance}}
    >
      <div>
        <ActionItemTemplate
          @header="Manage legal documents"
          @headerInfo="Add or edit a legal document for each visitor flow."
          @subHeader="Required plan: Standard"
          @iconLink="/assets/images/ipad-demo/icons/pencil.svg"
          @iconAlt="Image of NDA"
          @pageLink={{this.shareLink}}
          @isUserLoggedIn={{@isUserLoggedIn}}
          @demoName={{@demoName}}
          @isDemoInstance={{@isDemoInstance}}
        />
      </div>
    </PageTemplate>
  </template>
}
